module.exports = __webpack_public_path__ + "assets/webgl/Assets_4_base_color_L0.6e26ac50.jpg";